import useSWR from 'swr';

export default function useIsSeller() {
    const { data, error } = useSWR('users/is-seller');
    const isLoading = !error && !data;
    const isSeller = data && data.isSeller;
    
    return [isSeller, isLoading];
};